import { get as _get } from 'lodash';
import * as editorialAPI from '../common/api/editorial';
import getFeedGeotarget from '../utils/getFeedGeotarget';
import { redirectToNotFound } from './status';

export const FETCH_EDITORIAL_TAXONOMY_DETAILS = 'FETCH_EDITORIAL_TAXONOMY_DETAILS';
export const FETCH_EDITORIAL_TAXONOMY_DETAILS_SUCCESS = 'FETCH_EDITORIAL_TAXONOMY_DETAILS_SUCCESS';
export const FETCH_EDITORIAL_TAXONOMY_DETAILS_FAILURE = 'FETCH_EDITORIAL_TAXONOMY_DETAILS_FAILURE';

export const LOAD_MORE_EDITORIAL_TAXONOMY_DETAILS = 'LOAD_MORE_EDITORIAL_TAXONOMY_DETAILS';
export const LOAD_MORE_EDITORIAL_TAXONOMY_DETAILS_SUCCESS =
  'LOAD_MORE_EDITORIAL_TAXONOMY_DETAILS_SUCCESS';
export const LOAD_MORE_EDITORIAL_TAXONOMY_DETAILS_FAILURE =
  'LOAD_MORE_EDITORIAL_TAXONOMY_DETAILS_FAILURE';

export const ENABLE_INFINITE_SCROLLING_DETAILS = 'ENABLE_INFINITE_SCROLLING_DETAILS';

export const startInfiniteScrollingDetails = () => ({
  type: ENABLE_INFINITE_SCROLLING_DETAILS,
});

const TAXONOMY_LIST_LIMIT = 12;

export const fetchEditorialTaxonomyDetails =
  (
    taxonomy: string,
    term: string | null,
    subCategory: string | null,
    countryCode: string | null,
    isServer = false,
  ) =>
  async (dispatch: any, getState: any) => {
    dispatch({
      type: FETCH_EDITORIAL_TAXONOMY_DETAILS,
    });
    try {
      const termOverride = subCategory || term;
      const state = getState();
      const geotarget = countryCode || getFeedGeotarget(state);

      // Only paginate the list endpoint (no term), not individual term pages
      const isListPage = !termOverride;
      const details = await editorialAPI.fetchEditorialTaxonomyDetails({
        taxonomy,
        term: termOverride,
        geotarget,
        limit: isListPage ? TAXONOMY_LIST_LIMIT : null,
        offset: isListPage ? 0 : null,
        isServer,
      });
      dispatch({
        type: FETCH_EDITORIAL_TAXONOMY_DETAILS_SUCCESS,
        details,
      });
    } catch (error: any) {
      const wpStatusCode = _get(error, 'response.status', null);
      if (error.statusCode === 400 || wpStatusCode === 404) {
        dispatch(redirectToNotFound('The taxonomy details was not found'));
      } else {
        dispatch({
          type: FETCH_EDITORIAL_TAXONOMY_DETAILS_FAILURE,
          error,
        });
      }
    }
  };

export const loadMoreEditorialTaxonomyDetails = () => async (dispatch: any, getState: any) => {
  dispatch({ type: LOAD_MORE_EDITORIAL_TAXONOMY_DETAILS });
  try {
    const state = getState();
    const { details } = state.editorialTaxonomyDetails;
    if (!details) return;

    const { taxonomy, offset, limit } = details;
    const nextOffset = offset + limit;
    const geotarget = getFeedGeotarget(state);

    const moreDetails = await editorialAPI.fetchEditorialTaxonomyDetails({
      taxonomy,
      term: null,
      geotarget,
      limit,
      offset: nextOffset,
      isServer: false,
    });

    dispatch({
      type: LOAD_MORE_EDITORIAL_TAXONOMY_DETAILS_SUCCESS,
      subCategories: moreDetails.subCategories,
      offset: moreDetails.offset,
      hasMore: moreDetails.hasMore,
      total: moreDetails.total,
    });
  } catch (error: any) {
    const serializableError = {
      message: error.message || 'An unknown error occurred',
      statusCode: error.statusCode || null,
      name: error.name || 'Error',
    };
    dispatch({
      type: LOAD_MORE_EDITORIAL_TAXONOMY_DETAILS_FAILURE,
      error: serializableError,
    });
  }
};
